"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CirrusOAuthProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_oauth_1 = require("@yanzi/react-oauth");
const react_1 = require("react");
const useCirrusAuthenticationServer_1 = require("../../hooks/useCirrusAuthenticationServer");
const keyCloakRealms = ['tcop', 'cop'];
function CirrusOAuthProvider({ children }) {
    var _a;
    const realm = (_a = useCirrusAuthenticationServer_1.useCirrusAuthenticationServer().data) === null || _a === void 0 ? void 0 : _a.name;
    const clientId = react_1.useMemo(() => {
        if (realm === 'cop') {
            return 'yanzi-react-cop';
        }
        else {
            return 'yanzi-react';
        }
    }, [realm]);
    const keyCloakRealm = react_1.useMemo(() => {
        if (realm && keyCloakRealms.includes(realm)) {
            return realm;
        }
        else {
            return null;
        }
    }, [realm]);
    return (jsx_runtime_1.jsx(react_oauth_1.OAuthProvider, Object.assign({ clientId: clientId, keyCloakRealm: keyCloakRealm }, { children: children }), void 0));
}
exports.CirrusOAuthProvider = CirrusOAuthProvider;
//# sourceMappingURL=index.js.map